"use strict";

angular.module('rmOrganisation')

.config(['$stateProvider', function ($stateProvider) {

	$stateProvider
		.state('organisation', {
			url: "/organisation",

			    views: {

                'organisationoverview': {

                    templateUrl: '/partial/app.partials.organisation.overview',
                    controller: 'OrganisationOverviewCtrl',
                    controllerAs: 'organisationctrl'
                }
            },
			resolve: {
				Stripe: ['$q', function($q){
					return $q(function(resolve, reject){
						if (window.Stripe){
							return resolve(window.Stripe);
						} else if (document.getElementById('stripe_script')){
							setTimeout(() => resolve(window.Stripe), 100);
						} else {
							var script = document.createElement( 'script' );
							document.body.appendChild(script);
							script.id = 'stripe_script';
							script.type = 'text/javascript';
							script.src = 'https://js.stripe.com/v2/';
							script.onload = function(){
								resolve(window.Stripe);
							};
							script.onerror = reject;
						}
					});
				}]
			},
            onEnter: ['bladesManager', function( bladesManager ) {
            	bladesManager.clearAll();
            	bladesManager.insert({ viewName:'organisationoverview', size:'half' });
            }],

			/*
			templateUrl: '/partial/app.dashboard',
			controller: 'DashboardCtrl',
			controllerAs: 'ctrl'
			*/
		});
}]);



/*

"use strict";

var app = angular.module('rmOrganisation');

app.config(function ($stateProvider) {

	$stateProvider
		.state('organisationsettings', {
			url: "/organisationsettings",
			templateUrl: '/partial/app.partials.organisation.overview',
			controller: 'OrganisationOverviewCtrl',
			controllerAs: 'organisationctrl'

		});
});

*/
